import useRoute from './useRoute';
/**
 * This hook returns isDarkMode truthy value from Sitecore Context Route
 * @returns {boolean} truthy value of isDarkMode
 */
var useDarkFromRoute = function () {
    var _a;
    var route = useRoute();
    return (_a = route.fields.isDarkMode) === null || _a === void 0 ? void 0 : _a.value;
};
export default useDarkFromRoute;
